<button mat-icon-button
        [matTooltip]="'Действия'">
  <mat-icon>more_vert</mat-icon>
</button>
